import React from 'react';
import PropTypes from 'prop-types';
import Pagify from 'react-pagify';
import segmentize from 'segmentize';
import {Col} from 'react-bootstrap';
import pagifyBootstrapPreset from 'react-pagify-preset-bootstrap';

const Paginator = ({
  setPageIndex,
  getCanPreviousPage,
  getCanNextPage,
  getPageCount,
  currentPageIndex
}) => {
  const pageCount = getPageCount();
  const currentPage = currentPageIndex + 1; // Tanstack is zero-index
  const canGetNext = getCanNextPage();
  const canGetPrevious = getCanPreviousPage();

  if (pageCount <= 1) {
    return null;
  }

  return (
    <Col sm={12}>
      <div className={'text-center'}>
        <Pagify.Context
          {...pagifyBootstrapPreset}
          segments={segmentize({
            page: currentPage,
            pages: pageCount,
            beginPages: 1,
            endPages: 1,
            sidePages: 5,
          })}
          onSelect={(newPage) => setPageIndex(newPage - 1)}
        >
          {canGetPrevious &&
            <Pagify.Button
              id={'previous-page'}
              page={currentPage - 1}
            >❮ Previous</Pagify.Button>
          }
          <Pagify.Segment field={'beginPages'} />
          <Pagify.Ellipsis previousField={'beginPages'} nextField={'previousPages'} />
          <Pagify.Segment field={'previousPages'} />
          <Pagify.Segment field={'centerPage'} className={'active'} />
          <Pagify.Segment field={'nextPages'} />
          <Pagify.Ellipsis previousField={'nextPages'} nextField={'endPages'} />
          <Pagify.Segment field={'endPages'} />
          {canGetNext &&
            <Pagify.Button id={'next-page'} page={currentPage + 1}>Next ❯</Pagify.Button>
          }
        </Pagify.Context>
      </div>
    </Col>
  );
};

Paginator.propTypes = {
  setPageIndex: PropTypes.func,
  getCanPreviousPage: PropTypes.func,
  getCanNextPage: PropTypes.func,
  getPageCount: PropTypes.func,
  currentPageIndex: PropTypes.number,
};

export default Paginator;
